<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label required">
          {{ $t('disciplinarySubType.disciplinaryType') }}
        </label>
        <ts-search-select v-model.number="model.dis_type_id" :options="disciplinaryTypes"></ts-search-select>
        <div style="color:#cc4946;margin:4px 0 0">
          {{ errors.first('dis_type_id') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('disciplinarySubType.nameKH') }}
        </label>
        <input ref="dis_sub_type_kh" v-model="model.dis_sub_type_kh" type="text" class="form-control kh-font"
          :class="{ 'is-invalid': errors.has('dis_sub_type_kh') }" :placeholder="$t('disciplinarySubType.enternameKh')" />
        <div class="invalid-feedback" v-if="errors.has('dis_sub_type_kh')">
          {{ errors.first('dis_sub_type_kh') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label required">{{ $t('disciplinarySubType.nameEn') }}
        </label>
        <input v-model="model.dis_sub_type_en" type="text" class="form-control"
          :class="{ 'is-invalid': errors.has('dis_sub_type_en') }" :placeholder="$t('disciplinarySubType.enternameEn')" />
        <div class="invalid-feedback" v-if="errors.has('dis_sub_type_en')">
          {{ errors.first('dis_sub_type_en') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('disciplinarySubType.attStatus') }}
        </label>
        <select class="form-control" v-model="model.att_status_id">
          <option v-for="(status, index) in att_statuses" :value="status.att_status_id">
            {{ status.remark + ' ' + '(' + status.att_status + ')' }}
          </option>
        </select>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button class="ml-2" color="primary" :disabled="saving" :waiting="saving" @click="update"
          v-if="editing == true">
          {{ $t('update') }}
        </ts-button>
        <ts-button class="ml-2" color="primary" :disabled="saving" :waiting="saving" @click="save" v-else>
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'disciplinary-create-form',
  props: ['edit'],
  data() {
    return {
      model: {
        dis_sub_type_kh: '',
        dis_sub_type_en: '',
        att_status_id: '',
        dis_type_id: ''
      },
      att_statuses: [],
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  mounted() {
    this.$refs.dis_sub_type_kh.focus()
  },
  computed: {
    disciplinaryTypes() {
      return this.$store.state.disciplinarySubType.disciplinaryTypes.map(
        el => ({
          value: el.dis_type_id,
          text: el.dis_type_en + '|' + el.dis_type_kh
        })
      )
    }
  },
  async created() {
    await this.dataBeforeCreate()
    this.fetchAttStatus()
    this.setEdit()
  },
  methods: {
    ...mapActions('disciplinarySubType', ['dataBeforeCreate', 'getAttStatus']),
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'disciplinary-sub-type' })
    },
    fetchAttStatus() {
      this.getAttStatus()
        .then(response => {
          this.att_statuses = response.data
        })
    },
    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'disciplinarySubType/create',
          this.model
        )
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
        this.$refs.dis_sub_type_kh.focus()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'disciplinarySubType/update',
          this.model
        )

        this.$toasted.success(response.message)
        this.$router.push({ name: 'disciplinary-sub-type' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
        this.$refs.dis_sub_type_kh.focus()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      this.model = Object.assign({}, this.edit)
      this.editing = true
    },

    clearForm() {
      this.model.dis_sub_type_kh = ''
      this.model.dis_sub_type_en = ''
      this.model.dis_type_id = ''
      this.model.att_status_id = ''
    }
  },
  watch: {
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
